import React from 'react';
import classNames from 'classnames';
import { cta } from '../../../hoc/cta/cta.js';
import styles from './Button.scss.js';
import { sizeOptions } from '../../../helpers/enums/themes/sizeOptions.js';
import { bgColorOptions } from '../../../helpers/enums/themes/bgColorOptions.js';
import { fontColorOptions } from '../../../helpers/enums/themes/fontColorOptions.js';
import { paddingOptions } from '../../../helpers/enums/themes/paddingOptions.js';
import { fontWeightOptions } from '../../../helpers/enums/themes/fontStyleOptions.js';
import { outlineColorOptions } from '../../../helpers/enums/themes/outlineColorOptions.js';
import Tooltip from '../Tooltip/Tooltip/Tooltip.js';
import createTooltipPropObject from '../../../helpers/tooltip/getTooltipProp.js';
import { Theme } from '../../../helpers/enums/themes/themeTypes.js';

/**
 * Button properties
 */

// This interface exposes the button props above and certain props from the cta decorator that only the button needs (cta also contains
// generic properties not only related to buttons) this interface can be called where a component implements this button component
// within it like for example src/components/Core/AnnouncementMessage/AnnouncementMessage.tsx and
// core/src/components/Core/Cards/LessonCard/LessonCardHoverV2/LessonCardHoverV2.tsx

/**
 * @deprecated See Base Component Library (https://nearpod-packages.gitlab-pages.nearpod.com/base-component-library/?path=/docs/library-button--docs)
 */
const Button = _ref => {
  let {
    bgColor = bgColorOptions.transparent,
    fontColor = fontColorOptions.transparent,
    fontWeight = fontWeightOptions.medium,
    size = sizeOptions.medium,
    horizontalPadding = paddingOptions.medium,
    iconBefore,
    iconAfter,
    pill = false,
    isInFocus = false,
    children,
    tooltip,
    shouldDisplayLayerTransparent = true,
    outlineColor = outlineColorOptions.blue
  } = _ref;
  const renderTooltip = () => {
    if (!tooltip) return null;
    const tooltipProps = tooltip && createTooltipPropObject(tooltip.position);
    const theme = tooltip?.theme || Theme.YELLOW;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltip, {
        [styles[`tooltip--position-${tooltipProps.position}`]]: true,
        [styles[`tooltip--arrow-position-${tooltipProps.arrowPosition}`]]: tooltipProps.arrowPosition
      })
    }, /*#__PURE__*/React.createElement(Tooltip, {
      align: "center",
      arrow: tooltipProps.arrowPosition,
      theme: theme
    }, tooltip?.tooltipText));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.base, styles[size], styles[bgColor], styles[fontColor], styles[fontWeight], styles[outlineColor], {
      [styles.pill]: pill,
      [styles['base--focus']]: isInFocus,
      [styles['np-base']]: true,
      [styles['base--centered']]: !children
    })
  }, renderTooltip(), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['layer-container'], styles[horizontalPadding])
  }, iconBefore && /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.icon]: true,
      [styles.before]: !!children
    })
  }, iconBefore), children, iconAfter && /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.icon]: true,
      [styles.after]: !!children
    })
  }, iconAfter)), shouldDisplayLayerTransparent && /*#__PURE__*/React.createElement("div", {
    className: styles['layer-transparent']
  }));
};
var Button$1 = cta(Button);

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
